module.exports = __webpack_public_path__ + "img/logo.e0b0dad2.png";